import { FormData } from '../types';

// LocalStorage keys
export const STORAGE_KEYS = {
  AD_CONTENT: 'neodia_ad_content',
  AD_TEXT_CONTENT: 'neodia_ad_text_content',
  AD_BUTTON: 'neodia_ad_button',
  AD_LINK: 'neodia_ad_link',
  AD_IMAGE: 'neodia_ad_image',
  USER_TELEGRAM: 'neodia_user_telegram',
  CURRENT_AD_ID: 'current_ad_id'
};

// Save user data to localStorage
export const saveUserData = (formData: FormData): void => {
  try {
    // Save ad content
    localStorage.setItem(STORAGE_KEYS.AD_CONTENT, formData.adContent);
    localStorage.setItem(STORAGE_KEYS.AD_TEXT_CONTENT, formData.adTextContent);
    
    // Save button text and link
    localStorage.setItem(STORAGE_KEYS.AD_BUTTON, formData.buttonText);
    localStorage.setItem(STORAGE_KEYS.AD_LINK, formData.buttonLink);
    
    // Save image data if exists
    if (formData.imagePreview) {
      localStorage.setItem(STORAGE_KEYS.AD_IMAGE, formData.imagePreview);
    }
    
    console.log('User data saved successfully');
  } catch (error) {
    console.error('Error saving user data:', error);
  }
};

// Load saved user data from localStorage
export const loadSavedData = (): Partial<FormData> => {
  try {
    const savedData: Partial<FormData> = {};
    
    // Load ad content
    const savedContent = localStorage.getItem(STORAGE_KEYS.AD_CONTENT);
    if (savedContent) {
      savedData.adContent = savedContent;
    }
    
    const savedTextContent = localStorage.getItem(STORAGE_KEYS.AD_TEXT_CONTENT);
    if (savedTextContent) {
      savedData.adTextContent = savedTextContent;
    }
    
    // Load button text and link
    const savedButton = localStorage.getItem(STORAGE_KEYS.AD_BUTTON);
    if (savedButton) {
      savedData.buttonText = savedButton;
    }
    
    const savedLink = localStorage.getItem(STORAGE_KEYS.AD_LINK);
    if (savedLink) {
      savedData.buttonLink = savedLink;
    }
    
    // Load image
    const savedImage = localStorage.getItem(STORAGE_KEYS.AD_IMAGE);
    if (savedImage) {
      savedData.imagePreview = savedImage;
    }
    
    console.log('Saved user data loaded successfully');
    return savedData;
  } catch (error) {
    console.error('Error loading saved data:', error);
    return {};
  }
};

// Clear saved data
export const clearSavedData = (): void => {
  try {
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
    console.log('Saved data cleared successfully');
  } catch (error) {
    console.error('Error clearing saved data:', error);
  }
};

// Save current ad ID for payment tracking
export const saveCurrentAdId = (adId: string): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.CURRENT_AD_ID, adId);
  } catch (error) {
    console.error('Error saving current ad ID:', error);
  }
};

// Get current ad ID
export const getCurrentAdId = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEYS.CURRENT_AD_ID);
  } catch (error) {
    console.error('Error getting current ad ID:', error);
    return null;
  }
};

// Auto-save functionality with debouncing
export const createAutoSave = (callback: () => void, delay: number = 1000) => {
  let timeoutId: NodeJS.Timeout;
  
  return () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(callback, delay);
  };
}; 